import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useSelector } from "react-redux"

const FilterCard = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  selectAll,
  toggleSelectAll,
  selectedSurvey,
  setSelectedSurvey,
  nonRespondersOnly,
  setNonRespondersOnly,
  negativeFeedbackOnly,
  setNegativeFeedbackOnly,
  surveyAssignments,
}) => {
  const [uniqueSurveys, setUniqueSurveys] = useState([])
  const mode = useSelector(state => state.Layout.layoutMode)
  useEffect(() => {
    if (surveyAssignments) {
      console.log("Survey ASs", surveyAssignments)
      const extractedSurveys = Array.from(
        new Map(
          surveyAssignments.map(assignment => [
            assignment?.Survey?.id,
            { id: assignment?.Survey?.id, title: assignment?.Survey?.title },
          ]),
        ).values(),
      )
      setUniqueSurveys(extractedSurveys)
    }
  }, [surveyAssignments])

  const clearFilters = () => {
    setFromDate("")
    setToDate("")
    setSelectedSurvey("")
    setNonRespondersOnly(false)
    setNegativeFeedbackOnly(false)
  }

  return (
    <Card
      className="mb-4 shadow-sm br"
      style={{
        backgroundColor: mode === "dark" ? "#252F40" : "#fff",
      }}
    >
      <CardHeader
        className=" d-flex justify-content-between align-items-center "
        style={{
          backgroundColor: mode === "dark" ? "#252F40" : "#fff",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
        }}
      >
        <h5 className="mb-0">Filters</h5>
        <Button color="secondary" size="sm" onClick={clearFilters}>
          Clear Filters
        </Button>
      </CardHeader>
      <CardBody>
        <Row className="align-items-center">
          <Col md={4}>
            <FormGroup>
              <Label for="surveySelect">Select Survey</Label>
              <Input
                type="select"
                id="surveySelect"
                value={selectedSurvey}
                onChange={e => setSelectedSurvey(e.target.value)}
              >
                <option value="">All Surveys</option>
                {uniqueSurveys.map(survey => (
                  <option key={survey.id} value={survey.id}>
                    {survey.title}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          {selectedSurvey && (
            <Col md={4}>
              <FormGroup>
                <Label>Response Filter</Label>
                <Row className="align-items-center">
                  <Col>
                    <Input
                      type="checkbox"
                      id="nonResponders"
                      checked={nonRespondersOnly}
                      onChange={e => setNonRespondersOnly(e.target.checked)}
                    />
                    <Label for="nonResponders" className="ms-2">
                      Non-Responders
                    </Label>
                  </Col>
                  <Col>
                    <Input
                      type="checkbox"
                      id="negativeFeedback"
                      checked={negativeFeedbackOnly}
                      onChange={e => setNegativeFeedbackOnly(e.target.checked)}
                    />
                    <Label for="negativeFeedback" className="ms-2">
                      Negative Feedback
                    </Label>
                  </Col>
                </Row>
              </FormGroup>
            </Col>
          )}
          <Col
            md={4}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              style={{
                backgroundColor: selectAll ? "#5C636A" : "#2990DF",
                border: "none",
              }}
              onClick={toggleSelectAll}
            >
              {selectAll ? "Unselect All" : "Select All"}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default FilterCard
